import React, { useRef } from "react";
import useValidation from "app/common/custom-hooks/useValidation";
import SpinnerButton from "app/common/components/SpinnerButton";
import FormInput from "app/common/components/FormInput";
import { update } from "app/common/util/Helpers";
import { useDispatch, useSelector } from "react-redux";
import useActionListener from "app/common/custom-hooks/useActionListener";
import { requestEmailOTP, trackInvite } from "app/redux/auth/authHandler";
import { useNavigate } from "react-router-dom";
import ConditionalRender from "app/common/components/ConditionalRender";

const Step1 = ({setStepsData, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inviteEmail = useSelector(({auth}) => auth.invite?.email);
    const {validation, data: {email}} = useValidation(formRef, true, inviteEmail);

    // Form Submission process
    const handleSubmit = _ => {
        dispatch(requestEmailOTP(email));
    }

    useActionListener("emailOTPSent,failedRequestEmailOTP", (action, _, __, errorCode) => {
        if (action === "failedRequestEmailOTP" && errorCode === 205){
            navigate("/login");
        }
        else if (action === "emailOTPSent"){
            update(setStepsData, {email, step: 2});
        }
    })


    return  <div>
                <form onSubmit={handleSubmit} ref={formRef}>
                    <h2
                        className="text-3xl md:text-[2.5rem] md:leading-[3rem] text-black-1 font-semibold pb-2 dark:text-white "
                    >
                        Making Commerce as Simple as A Chat
                    </h2>
                    <p
                        className="pb-12 text-grey-7"
                    >
                        Sign up to get started
                    </p>
                    <div className="">
                        <FormInput
                            label="Email:"
                            type='email' 
                            placeholder="example@mail.com" 
                            required 
                            name="email"
                            validation={validation}
                            invalidMessage="Enter a valid email address"
                            defaultValue={inviteEmail}
                            readOnly={!!inviteEmail}
                            key={`field-${inviteEmail}`}
                        />
                        <div className="mt-9 mb-2">
                            <SpinnerButton 
                                type="submit" 
                                disabled={!validation.allValid} 
                                className="w-full btn-primary btn-md" 
                                isLoading={isLoading}
                                text={inviteEmail ? "Continue to join team" : "Sign up"}
                            />
                        </div>
                        <ConditionalRender
                            render={!!inviteEmail}
                        >
                            <div
                                className="py-8"
                            >
                                <hr />
                                <p className="text-center -mt-2.5">
                                    <span
                                        className="inline-block px-5 bg-white"
                                    >
                                        or
                                    </span>
                                </p>
                            </div>
                            <div className="space-y-5">
                                <button
                                    className="w-full btn-outline btn-md font-medium"
                                    type="button"
                                    onClick={_ => dispatch(trackInvite(null))}
                                >
                                    Create your business
                                </button>
                            </div> 
                        </ConditionalRender>
                        {/* <div className="space-y-5">
                            <button
                                className="w-full btn-outline btn-md font-medium"
                                type="button"
                            >
                                <img
                                    src="/assets/media/image/google.png" alt="G" className="w-4 mr-2 -mt-1 inline"
                                /> Sign up with Google
                            </button>
                        </div> */}
                    </div>
                </form>
            </div>
}

export default Step1;